import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Card,
  CardHeader,
  CardContent,
  makeStyles,
  Divider,
  Typography,
  InputAdornment,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import PersonIcon from "@material-ui/icons/Person";
import HomeIcon from "@material-ui/icons/Home";
import LockIcon from "@material-ui/icons/Lock";

import { useAlert } from "react-alert";
import { UpdateUsers, getUserByID } from "../../../adminModel/users";
import { Country, State, City } from "country-state-city";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useParams } from "react-router-dom";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },

  card: {
    width: "100%",
    borderRadius: 12,
    overflow: "hidden",
  },

  header: {
    backgroundColor: "#fafafa",
    padding: theme.spacing(2.5, 3),
  },

  headerTitle: {
    fontWeight: 600,
  },

  section: {
    marginBottom: theme.spacing(3),
  },

  sectionHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(0.5),
  },

  sectionIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
  },

  sectionTitle: {
    fontWeight: 600,
  },

  sectionDescription: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2.5),
  },

  field: {
    width: "100%",
  },

  actionBar: {
    padding: theme.spacing(2),
    backgroundColor: "#fafafa",
    display: "flex",
    justifyContent: "flex-end",
  },

  updateButton: {
    minWidth: 130,
    height: 44,
    fontWeight: 600,
  },

  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default function View(props) {
  const classes = useStyles();
  const alert = useAlert();
  const { id } = useParams();

  const [values, setValues] = useState({
    firstname: "",
    lastname: "",
    dob: "",
    ip_address: "",
    address: "",
    second_address_line: "",
    postal_code: "",
    city: "",
    country: "",
    email: "",
    password: "",
    confirm: "",
    phone: "",
    nationality: "",
    user_type: "",
  });

  const [loading, setLoading] = useState(false);

  const [errorMaximun, setErrorMaximum] = useState("");
  const [errorMax, setErrorMax] = useState(false);

  const [validUsername, setValidUsername] = useState("");
  const [errorUsername, setErrorUsername] = useState(false);

  const [valid, setValid] = useState("");
  const [error, setError] = useState(false);

  const [getIsocode, setIsocOde] = useState("");
  const [getCountry, setCountry] = useState("");
  const [getCityCode, setCityCode] = useState("");
  const [getCity, setGetCity] = useState("");
  const [getState, setGetState] = useState("");

  // =========================
  // HANDLE CHANGE
  // =========================
  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });

    if (event.target.name === "username") {
      const isValidPasswordRegex = /[a-zA-Z0-9]$/;

      if (!isValidPasswordRegex.test(event.target.value)) {
        setErrorUsername(true);
        setValidUsername(
          "The username may only contain letters, numbers, dashes and underscores."
        );
      } else {
        setValidUsername("");
        setErrorUsername(false);
      }
    } else if (event.target.name === "phone") {
      if (10 === event.target.value.length) {
        setErrorMax(false);
        setErrorMaximum("");
      } else {
        setErrorMax(true);
        setErrorMaximum(
          "Sample Format Number +63 9123456789"
        );
      }
    } else if (event.target.name === "country") {
      // Existing logic retained
    } else {
      setValues({
        ...values,
        [event.target.name]: event.target.value,
      });
    }
  };

  // =========================
  // UPDATE USER
  // =========================
  const handeleUserUpdate = async (e) => {
    e.preventDefault();

    if (errorMax === true) {
      alert.error("Wrong Phone Number Format");
    } else if (errorUsername === true) {
      alert.error(
        "he username may only contain letters, numbers, dashes and underscores."
      );
    } else {
      if (values.password !== values.confirm) {
        setValid(
          "Password and confirm password does not match"
        );
        setError(true);
      } else {
        setValid("");
        setError(false);

        const ArrayAddUser = {
          firstname: values.firstname
            ? values.firstname
            : values.firstname,

          lastname: values.lastname
            ? values.lastname
            : values.lastname,

          dob: values.dob
            ? values.dob
            : values.dob,

          address: values.address
            ? values.address
            : values.address,

          second_address_line: getState
            ? getState
            : values.second_address_line,

          postal_code: values.postal_code
            ? values.postal_code
            : values.postal_code,

          city: getCity
            ? getCity
            : values.city,

          nationality: values.nationality
            ? values.nationality
            : values.nationality,

          user_type: values.user_type
            ? values.user_type
            : values.user_type,

          country: values.country
            ? getCountry
            : values.country,
        };

        setLoading(true);

        try {
          const result = await UpdateUsers(
            id,
            ArrayAddUser
          );

          alert.success(result);
          setLoading(false);
        } catch (e) {
          console.log(e);
          setLoading(false);
        }
      }
    }
  };

  // =========================
  // COUNTRY / STATE / CITY
  // =========================
  const handlepick = (e, v) => {
    try {
      setIsocOde(v.value);
      setCountry(v.displayValue);
    } catch (error) {
      setIsocOde("");
      console.log("error");
    }
  };

  const handlepick1 = (e, v) => {
    try {
      setCityCode(v.value);
      setGetState(v.displayValue);
    } catch (error) {
      console.log("error");
    }
  };

  const handlepick2 = (e, v) => {
    try {
      setGetCity(v.value);
    } catch (error) {
      console.log("error.", error);
    }
  };

  // =========================
  // LOCATION DATA
  // =========================
  const data = Country.getAllCountries().map(
    (country) => ({
      value: country.isoCode,
      displayValue: `${country.name}`,
    })
  );

  const stateData = State.getStatesOfCountry(
    getIsocode
  ).map((state) => ({
    value: state.isoCode,
    displayValue: state.name,
  }));

  const dataCity = City.getCitiesOfState(
    getIsocode,
    getCityCode
  ).map((city) => ({
    value: city.name,
    displayValue: city.name,
  }));

  // =========================
  // GET USER
  // =========================
  const Users = useCallback(async () => {
    setLoading(true);

    async function getAuction() {
      const results = await getUserByID(id);

      setLoading(false);

      let row = {};

      results.map((val) => {
        return (row = val);
      });

      setValues({
        firstname: row.firstname,
        lastname: row.lastname,
        dob: row.dob,
        address: row.address,
        second_address_line: row.second_address_line,
        postal_code: row.postal_code,
        city: row.city,
        country: row.country,
        email: row.email,
        password: row.password,
        confirm: row.password,
        phone: row.phone,
        nationality: row.nationality,
        user_type: row.user_type,
      });
    }

    getAuction().catch(console.error);
  }, [id]);

  useEffect(() => {
    Users();
  }, [Users]);

  return (
    <Box className={classes.root}>
      <Card
        className={classes.card}
        elevation={1}
      >
        {/* =========================
            PAGE HEADER
        ========================= */}
        <CardHeader
          className={classes.header}
          avatar={<EditIcon color="primary" />}
          title={
            <Typography
              variant="h6"
              className={classes.headerTitle}
            >
              Edit User
            </Typography>
          }
          subheader="Update the user's personal information and account details"
        />

        <Divider />

        <CardContent>
          {/* =========================
              PERSONAL INFORMATION
          ========================= */}
          <Box className={classes.section}>
            <Box className={classes.sectionHeader}>
              <PersonIcon className={classes.sectionIcon} />

              <Typography
                variant="h6"
                className={classes.sectionTitle}
              >
                Personal Information
              </Typography>
            </Box>

            <Typography
              variant="body2"
              className={classes.sectionDescription}
            >
              Update the user's basic personal details.
            </Typography>

            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <TextField
                  required
                  fullWidth
                  label="First Name"
                  name="firstname"
                  value={values.firstname}
                  onChange={handleChange}
                  variant="outlined"
                  className={classes.field}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  required
                  fullWidth
                  label="Last Name"
                  name="lastname"
                  error={errorUsername}
                  helperText={validUsername}
                  value={values.lastname}
                  onChange={handleChange}
                  variant="outlined"
                  className={classes.field}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  required
                  fullWidth
                  label="Date of Birth"
                  name="dob"
                  type="date"
                  value={values.dob}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  className={classes.field}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  required
                  fullWidth
                  label="Nationality"
                  name="nationality"
                  type="text"
                  value={values.nationality}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  className={classes.field}
                />
              </Grid>
            </Grid>
          </Box>

          <Divider />

          {/* =========================
              CONTACT INFORMATION
          ========================= */}
          <Box
            className={classes.section}
            mt={3}
          >
            <Box className={classes.sectionHeader}>
              <PersonIcon className={classes.sectionIcon} />

              <Typography
                variant="h6"
                className={classes.sectionTitle}
              >
                Contact Information
              </Typography>
            </Box>

            <Typography
              variant="body2"
              className={classes.sectionDescription}
            >
              Update the user's phone number and email address.
            </Typography>

            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <TextField
                  required
                  fullWidth
                  error={errorMax}
                  helperText={errorMaximun}
                  label="Phone Number"
                  name="phone"
                  value={values.phone}
                  onChange={handleChange}
                  inputProps={{
                    minLength: "9",
                    maxLength: "10",
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        +63
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  className={classes.field}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  required
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  value={values.email}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  className={classes.field}
                />
              </Grid>
            </Grid>
          </Box>

          <Divider />

          {/* =========================
              ADDRESS
          ========================= */}
          <Box
            className={classes.section}
            mt={3}
          >
            <Box className={classes.sectionHeader}>
              <HomeIcon className={classes.sectionIcon} />

              <Typography
                variant="h6"
                className={classes.sectionTitle}
              >
                Address
              </Typography>
            </Box>

            <Typography
              variant="body2"
              className={classes.sectionDescription}
            >
              Update the user's country, state, city, and address.
            </Typography>

            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <Autocomplete
                  disablePortal
                  options={data}
                  getOptionLabel={(option) =>
                    option.displayValue ||
                    values.country
                  }
                  getOptionSelected={(option) =>
                    option.displayValue
                  }
                  value={values.country}
                  onChange={(e, v) => {
                    handlepick(e, v);
                  }}
                  fullWidth
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Country"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <Autocomplete
                  disablePortal
                  options={stateData}
                  getOptionLabel={(option) =>
                    option.displayValue ||
                    values.second_address_line
                  }
                  getOptionSelected={(option) =>
                    option.displayValue
                  }
                  value={values.second_address_line}
                  onChange={(e, v) => {
                    handlepick1(e, v);
                  }}
                  fullWidth
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="State"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <Autocomplete
                  options={dataCity}
                  getOptionLabel={(option) =>
                    option.displayValue ||
                    values.city
                  }
                  getOptionSelected={(option) =>
                    option.displayValue
                  }
                  value={values.city}
                  onChange={(e, v) => {
                    handlepick2(e, v);
                  }}
                  fullWidth
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="City"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  required
                  fullWidth
                  label="Postal Code"
                  name="postal_code"
                  value={values.postal_code}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  className={classes.field}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  label="Address"
                  name="address"
                  multiline
                  minRows={3}
                  value={values.address}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  className={classes.field}
                />
              </Grid>
            </Grid>
          </Box>

          <Divider />

          {/* =========================
              PASSWORD
          ========================= */}
          <Box mt={3}>
            <Box className={classes.sectionHeader}>
              <LockIcon className={classes.sectionIcon} />

              <Typography
                variant="h6"
                className={classes.sectionTitle}
              >
                Change Password
              </Typography>
            </Box>

            <Typography
              variant="body2"
              className={classes.sectionDescription}
            >
              Update the user's password.
            </Typography>

            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <TextField
                  required
                  fullWidth
                  label="Password"
                  name="password"
                  type="password"
                  error={error}
                  value={values.password}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  className={classes.field}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  required
                  fullWidth
                  error={error}
                  helperText={valid}
                  label="Confirm Password"
                  name="confirm"
                  type="password"
                  value={values.confirm}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  className={classes.field}
                />
              </Grid>
            </Grid>
          </Box>
        </CardContent>

        <Divider />

        {/* =========================
            ACTION
        ========================= */}
        <Box className={classes.actionBar}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
            onClick={handeleUserUpdate}
            className={classes.updateButton}
            disabled={loading}
          >
            {loading ? "Updating..." : "Update"}
          </Button>
        </Box>
      </Card>

      {/* =========================
          LOADING
      ========================= */}
      <Backdrop
        className={classes.backdrop}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}